// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3562K","name":"styles_name__2zCPI","phone":"styles_phone__1lb6X"};